import { useApiResources } from "./ApiResources";
import { useAppSidebarStore } from "./AppSidebar";
import { useUserStore } from "./User";

type ApplicationMode = "DEV" | "USER";

export const useAppStore = defineStore("App", () => {
	const appMode = ref<ApplicationMode>(import.meta.env.DEV ? "DEV" : "USER");
	const appTitle = computed(() => {
		const title = import.meta.env.VITE_APP_TITLE || "PulseFood";
		const version = __APP_BUILD_VERSION__;
		const timestamp = __APP_BUILD_TIMESTAMP__;
		return appMode.value == "DEV" ? `${title}__${version}__${timestamp}` : title;
	});
	const showGlobalSearch = ref(false);
	const showQBotSearch = ref(false);

	function setMode(mode: ApplicationMode) {
		appMode.value = mode;
	}

	function refreshApp() {
		const { refreshUserInfo } = useUserStore();
		const { refreshSidebar } = useAppSidebarStore();
		const { refreshResources } = useApiResources();

		return Promise.allSettled([refreshUserInfo(), refreshSidebar(), refreshResources()]);
	}

	return {
		setMode,
		appMode: computed(() => appMode.value),
		appTitle,
		refreshApp,
		showGlobalSearch,
		showQBotSearch,
	};
});
